import { HeaderPro } from '../../components/HeaderPro';
import { Footer } from '../../components/Footer';
import { InboxList } from '../../components/InboxList';
import { RequirePro } from '../../../lib/use-auth';

export default function ProInboxPage() {
  return (
    <RequirePro>
      <div className="min-h-screen bg-white flex flex-col">
        <HeaderPro />
        <main className="flex-1 py-6 md:py-12">
          <InboxList role="professional" />
        </main>
        <Footer />
      </div>
    </RequirePro>
  );
}
